import React, { useEffect } from "react";
import { FaShieldAlt } from "react-icons/fa";
import { MdOutlineWbSunny } from "react-icons/md";
import { BsMoonFill } from "react-icons/bs";
import { useAppContext } from "../Context/AppProvider";
import Swal from "sweetalert2";

const Header = ({ setDarkMode, darkMode, lockLightMode = false, isUserPage = false }) => {
  console.log("🚀 ~ Header ~ lockLightMode:", lockLightMode)
  const { logoutAdmin = () => {} } = useAppContext() || {};

  // Set theme to light in localStorage when lockLightMode is true
  useEffect(() => {
    if (lockLightMode && isUserPage) {
      localStorage.setItem("theme", "light");
      setDarkMode(false);
    }
    else{
         localStorage.setItem("theme", "dark");
      setDarkMode(true);
    }
  }, [lockLightMode, isUserPage, setDarkMode]);

  const handleThemeToggle = () => {
    // Don't allow theme toggle if locked to light mode on user pages
    if (lockLightMode && isUserPage) return;
    
    const newMode = !darkMode;
    localStorage.setItem("theme", newMode ? "dark" : "light");
    setDarkMode(newMode);
  };

  return (
    <header className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-xl border-b border-gray-200/50 dark:border-gray-700/50 text-black dark:text-white px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between shadow-sm">
      <div className="flex items-center gap-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center shadow-lg">
            <FaShieldAlt className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
              SmartStart AI
            </h1>
            <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
              Your Personal Cashflow Assistant
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {!(lockLightMode && isUserPage) && (
          <button
            onClick={handleThemeToggle}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
            aria-label="Toggle theme"
          >
            {darkMode ? (
              <BsMoonFill className="w-5 h-5 text-yellow-500" />
            ) : (
              <MdOutlineWbSunny className="w-5 h-5 text-gray-600" />
            )}
          </button>
        )}

        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
          <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 hidden sm:inline">
            Online
          </span>
        </div>

        {/* <button
          onClick={async () => {
            const result = await Swal.fire({
              title: "Are you sure you want to logout?",
              text: "You will be redirected to the home page.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, logout!",
              cancelButtonText: "Cancel",
              customClass: {
                confirmButton: "swal2-confirm-button",
                cancelButton: "swal2-cancel-button",
              },
            });

            if (result.isConfirmed) {
              localStorage.clear();
              await logoutAdmin();
             
              window.location.href = "/";
            }
          }}
          className=" px-4 py-2 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors duration-200"
        >
          Logout
        </button> */}
      </div>
    </header>
  );
};

export default Header;
